import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@mui/material";
import Button from "@mui/material/Button";

export default function UserAccessDialog({ open, onClose, title, userAccessData }) {
    return (
        <Dialog role="alertdialog" open={open} fullWidth maxWidth="md" aria-labelledby="access-dialog-title" aria-describedby="access-dialog-description" sx={{ zIndex: 1600 }}>
            <DialogTitle id="access-dialog-title" style={{ textAlign: "center", fontWeight: "bold" }}>
                {title}
            </DialogTitle>
            <DialogContent id="access-dialog-description" tabIndex={-1}>
                {userAccessData && userAccessData.length > 0 ? (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="body2" fontWeight="bold">
                                            Page / Permission
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2" fontWeight="bold">
                                            View
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2" fontWeight="bold">
                                            Add
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2" fontWeight="bold">
                                            Update
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2" fontWeight="bold">
                                            Delete
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {["Projects", "Strategy Types", "Roadways", "Regions", "Users"].map(
                                    (rowHeader, rowIndex) => (
                                        <TableRow key={rowIndex}>
                                            <TableCell component="th" scope="row">
                                                <Typography variant="body2" fontWeight="bold">
                                                    {rowHeader}
                                                </Typography>
                                            </TableCell>
                                            {userAccessData[rowIndex].map((cell, colIndex) => (
                                                <TableCell key={colIndex}>{cell}</TableCell>
                                            ))}
                                        </TableRow>
                                    )
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Typography variant="body1" color="textSecondary" align="center">
                        No data
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}